import React from 'react';
import { Box } from '@mui/material';
import normalizeMessage from './normalizeMessage';
import MessageReplyPreview from './MessageReplyPreview';
import MessageSenderLabel from './MessageSenderLabel';
import MessageContentRenderer from './MessageContentRenderer';
import MessageMeta from './MessageMeta';

const Message = ({ message, scrollToMessage }) => {
  const normalizedMessage = normalizeMessage(message);

  console.log('Message render', { normalizedMessage });
  return (
    <>
      <MessageReplyPreview message={normalizedMessage} scrollToMessage={scrollToMessage} />
      <MessageSenderLabel message={normalizedMessage} />
      <MessageContentRenderer message={normalizedMessage} />
      <MessageMeta message={normalizedMessage} />
      {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
        <MessageMeta message={normalizedMessage} />
      </Box> */}
    </>
  );
};

export default Message;
